//
// User blocks other user
//
import { API_USER } from '../config';
import { sendRequest } from '../send_request';

export const userBlockRequest = async (userId) => await sendRequest(API_USER.BLOCK_USER_URL(userId), 'POST', null);
